import { MediaKind } from "@warda/library-ui/contexts/AppMediaTypeContext";
import apiUrls from "../api/apiUrlsSharePage";
import { RENDITION } from "../interfaces";
const getThumbnailData = ({ fileId, renditions, }) => {
    const rendition = renditions.find((rendition) => rendition.code === "THUMBNAIL" /* HIDDEN_RENDITION.video_thumbail */);
    return rendition
        ? {
            srcThumbnail: apiUrls.mediaDownload.url(fileId, rendition.code),
            mimeTypeThumbnail: rendition.mimeType,
        }
        : undefined;
};
const getHoverData = ({ fileId, renditions, }) => {
    const rendition = renditions.find((rendition) => rendition.code === RENDITION.video_LQ);
    return rendition
        ? {
            srcHover: apiUrls.mediaDownload.url(fileId, rendition.code),
            mimeTypeHover: rendition.mimeType,
        }
        : undefined;
};
const getSPVideoPreviewUrls = ({ fileId, renditions = [], mimeType, mimeTypeToMediaKind, }) => {
    if (!fileId)
        return {};
    const mediaKind = mimeTypeToMediaKind(mimeType);
    const isVideo = mediaKind === MediaKind.VID;
    return isVideo
        ? {
            ...getThumbnailData({ fileId, renditions }),
            ...getHoverData({ fileId, renditions }),
        }
        : {};
};
export default getSPVideoPreviewUrls;
